import { currentUserNotificationsBySubscription } from 'conversations/modules/user/sections/selectors'
import { useSelector } from 'react-redux'

export enum SectionNotification {
  ON,
  OFF,
  NONE,
}

export default function useSectionNotifications(subscriptionId?: string): SectionNotification {
  const notificationsBySubscription = useSelector(currentUserNotificationsBySubscription)
  if (!subscriptionId) {
    return SectionNotification.NONE
  }

  const sectionHasNotifications =
    notificationsBySubscription[subscriptionId]?.allNotificationsForSubscriptionEnabled

  return sectionHasNotifications ? SectionNotification.ON : SectionNotification.OFF
}
